const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

export const normalizeApiHtmlContent = (html: string): string => {
  if (!html || !isBrowser) {
    return html || '';
  }

  const container = document.createElement('div');
  container.innerHTML = html;

  container.querySelectorAll('img').forEach((img) => {
    img.style.maxWidth = '100%';
    img.style.height = 'auto';
    img.style.display = 'block';
    img.setAttribute('loading', 'eager');
    img.setAttribute('decoding', 'async');
  });

  container.querySelectorAll('iframe').forEach((iframe) => {
    iframe.style.width = '100%';
    iframe.style.maxWidth = '100%';
    iframe.style.border = '0';
    iframe.style.display = 'block';
  });

  return container.innerHTML;
};

export const extractImageUrlsFromHtml = (html: string): string[] => {
  if (!html || !isBrowser) {
    return [];
  }

  const container = document.createElement('div');
  container.innerHTML = html;

  return Array.from(container.querySelectorAll('img'))
    .map((img) => img.getAttribute('src') || '')
    .filter(Boolean);
};

export const preloadImages = (urls: string[]): Promise<void> => {
  if (!isBrowser || urls.length === 0) {
    return Promise.resolve();
  }

  const uniqueUrls = Array.from(new Set(urls));

  return Promise.all(
    uniqueUrls.map(
      (url) =>
        new Promise<void>((resolve) => {
          const image = new Image();
          image.onload = () => resolve();
          image.onerror = () => resolve();
          image.src = url;
        })
    )
  ).then(() => undefined);
};

export const preloadImagesFromHtmlBlocks = (htmlBlocks: string[]): Promise<void> => {
  const urls = htmlBlocks.flatMap((html) => extractImageUrlsFromHtml(html));
  return preloadImages(urls);
};
